import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { fetchHistory } from '../actions';
import { selectEmailHistory } from '../selector';
import { FILTER_DEFAULT_LIMIT } from '../constants';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { EmailHistoryOverviewPagination } from '../components/Pagination';
import { COLOR_TABLE_HEADER } from '../../../vars';
import dayjs from 'dayjs';
import { Well } from '../../../components/Well';

const Container = styled.div`
  padding: 24px;
  background-color: white;
  margin-bottom: 22px;

  .rows {
    .check-col {
      min-width: 40px;
      text-align: center;
    }
    background-color: white;
    .header {
      background-color: ${COLOR_TABLE_HEADER};
      color: red;
      .box {
        height: 52px;
        white-space: nowrap;
        flex-shrink: 0;
        > div {
          font-weight: 600;
        }
      }
      @media (max-width: 768px) {
        display: none;
      }
    }

    .header-col {
      overflow: hidden;
      width: auto;
      width: 85px;
      font-size: 12px;

      text-transform: capitalize;

      &.col-createdAt {
        width: 10%;
      }

      &.col-from {
        width: 20%;
      }

      &.col-to {
        width: 20%;
      }

      &.col-subject {
        width: 25%;
      }

      &.col-text {
        width: 10%;
      }

      &.col-status {
        width: 10%;
      }
    }

    .item-cell {
      font-size: 14px;
      padding: 4px;
      width: 85px;

      &:last-child {
        justify-content: flex-end;
        text-align: right;
      }
    }

    .col-createdAt {
      width: 10%;
    }

    .col-from {
      width: 20%;
    }
    .col-to {
      width: 20%;
    }
    .col-subject {
      width: 25%;
    }

    .col-text {
      width: 10%;
    }

    .col-status {
      width: 10%;
    }

    .item-row {
      border-bottom: 1px solid ${COLOR_TABLE_HEADER};
    }
  }

  .message {
    padding: 12px;
    margin: 12px;
    font-size: 12px;
    background-color: #ddd;
  }
`;

const STATE = {
  show: {},
};

class EmailHistoryOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  cols() {
    return ['id', 'createdAt', 'from', 'to', 'subject', 'status'];
  }

  renderHeaderCell(col) {
    switch (col) {
      default:
        return this.lbl(`email_history.overview.column.${col}`);
    }
  }

  renderCell(col, email) {
    const fn = () => {
      switch (col) {
        case 'createdAt':
          return (
            <span key={col.createdAt} style={{ whiteSpace: 'nowrap' }}>
              {dayjs(email?.createdAt).format('DD-MM-YYYY hh:mm:ss')}
            </span>
          );
          break;
        default:
          return email[col];
      }
    };

    return (
      <div className={`item-cell col-${col}`} key={`${col}-${email.id}`}>
        {fn()}
      </div>
    );
  }

  renderRow(email) {
    return (
      <>
        <HBox
          className="item-row"
          vCenter
          left
          key={email.id}
          onClick={this.setStateFn({ show: { ...this.state.show, [email.id]: !this.state.show[email.id] } })}
        >
          {this.cols().map(col => {
            return this.renderCell(col, email);
          })}
        </HBox>
        {this.state.show[email.id] ? (
          <VBox key={`msg-${email.id}`}>
            {email.attachment ? (
              <Well>
                <div onClick={() => window.open(email?.attachment?.path)}>
                  Attachment : {email?.attachment?.filename ?? 'attachment'}
                </div>
              </Well>
            ) : null}
            <div className="message" dangerouslySetInnerHTML={{ __html: email.html }}></div>
          </VBox>
        ) : null}
      </>
    );
  }

  render() {
    if (!this.props.emails) return <Loader />;
    return (
      <>
        <Container>
          <div className="rows">
            <div className="header">
              <HBox vCenter left>
                {this.cols().map((col, index) => (
                  <HBox className={`header-col col-${col}`} key={`${col}-${index}`} vCenter>
                    {this.renderHeaderCell(col)}
                  </HBox>
                ))}
              </HBox>
            </div>
            {this.props.emails?.filter(e => e).map(email => this.renderRow(email))}
          </div>
        </Container>
        <HBox vCenter center>
          <EmailHistoryOverviewPagination />
        </HBox>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    emails: selectEmailHistory(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: callback => {
      dispatch(fetchHistory(0, FILTER_DEFAULT_LIMIT, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const EmailHistoryOverview = compose(withConnect, withRouter)(EmailHistoryOverviewComp);
